export default __webpack_public_path__ + "static/media/cubierta.eaaa8b9b.svg";